import { render, staticRenderFns } from "./OwnBrandProductDetail.vue?vue&type=template&id=1a6dfba7&"
import script from "./OwnBrandProductDetail.vue?vue&type=script&lang=js&"
export * from "./OwnBrandProductDetail.vue?vue&type=script&lang=js&"
import style0 from "./OwnBrandProductDetail.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports